module.exports = __webpack_public_path__ + "static/senior-1-7a4bfd383204a0b635bd00760bcd5162.png";